export default __webpack_public_path__ + "static/media/freeOnlineCourses.a11898ac.svg";